import $ from "jquery";
import React, { useEffect } from "react";

export default function ScrollUp() {

    useEffect(() => {
        $(document).ready(function ($) {
            $(window).scroll(function () {
                var scroll = $(window).scrollTop();
                if (scroll < 400) {
                    $(".scroll-to-target").removeClass("open");
                } else {
                    $(".scroll-to-target").addClass("open");
                }
            });
        });
    }, []);

    return (
        <>
            <button className="scroll-top scroll-to-target" data-target="html">
                <a href="#scroll-up">
                    <i className="fa-solid fa-chevron-up"></i>
                    {/* <i className="far fa-angle-double-up"></i> */}
                </a>
            </button>
        </>
    )
}
